import script from "./workRecords.vue?vue&type=script&setup=true&lang=js"
export * from "./workRecords.vue?vue&type=script&setup=true&lang=js"

import "./workRecords.vue?vue&type=style&index=0&id=3838b91c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3838b91c"]])

export default __exports__